/**************************************************
 * Nombre:       Dashboard
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import DashboardBase from "../Modulo_Dashboard/Componentes/DashboardBase";
import React, {createContext, useContext, useEffect, useState} from "react";
import {
    BadgeOutlined,
    LayersOutlined,
    PersonAddAltOutlined,
    WarningOutlined,
    WorkspacePremiumOutlined
} from "@mui/icons-material";
import {funSalir} from "../Servicios/Auth/funSalir";
import {usuarioContext} from "../App";
import Seccion_Usuarios from "./Secciones/Seccion_Usuarios";
import Seccion_Clientes_Potenciales from "./Secciones/Seccion_Clientes_Potenciales";
import Seccion_Adicional from "./Secciones/Seccion_Adicional";
import Seccion_Pqrss from "./Secciones/Seccion_Pqrss";
import Seccion_Autorizaciones from "./Secciones/Seccion_Autorizaciones";


export const contexBarra = createContext()
const Dashboard = () => {
    const [notificaciones, setNotificaciones] = useState([])
    const [nuevasNotificaciones, setNuevasNotificaciones] = useState(0)
    const [historial, setHistorial] = useState([])
    const [nuevoHistorial, setNuevoHistorial] = useState(0)
    const {usuario} = useContext(usuarioContext)

    const [open, setOpen] = useState(false)
    const salir = () => {
        funSalir()
    }

    const valoresBarra = {
        notificaciones,
        nuevasNotificaciones,
        historial,
        nuevoHistorial,
        funSalir: salir

    }


    const {Provider} = contexBarra;


    useEffect(() => {


    }, [usuario]);
    return (
        <Grid
            container
            size={12}
        >


            <Provider value={valoresBarra}>
                <DashboardBase secciones={secciones} seccionesPerfil={seccionesPerfil} seccionesID={seccionesID}/>
            </Provider>

        </Grid>
    )

}
export default Dashboard

const secciones = [
    {
        nombre: 'Casos Potenciales',
        icono: PersonAddAltOutlined,
        camino: '/CasosPotenciales',
        categoria: 'Pagina',
        Componente: <Seccion_Clientes_Potenciales/>
    },
    /*{
        nombre: 'Cursos',
        icono: MenuBookOutlined,
        camino: '/Cursos',
        categoria: 'Configuraciones',
        privada: false,
        Componente: <Seccion_Cursos/>
    },*/
    {
        nombre: 'Autorizaciones',
        icono: WorkspacePremiumOutlined,
        camino: '/Autorizaciones',
        categoria: 'Pagina',
        Componente: <Seccion_Autorizaciones/>
    },

    {
        nombre: 'Pqrsfs',
        icono: WarningOutlined,
        camino: '/Pqrsfs',
        categoria: 'Pagina',
        Componente: <Seccion_Pqrss/>
    },
    {
        nombre: 'Adicionales',
        icono: LayersOutlined,
        camino: '/Adicionales',
        categoria: 'Configuraciones',
        Componente: <Seccion_Adicional/>
    },
    {
        nombre: 'Usuarios',
        icono: BadgeOutlined,
        camino: '/Usuarios',
        categoria: 'Configuraciones',
        privada: false,
        Componente: <Seccion_Usuarios/>
    }
]

const seccionesID = []

const seccionesPerfil = []

const notificaciones = {}